module.exports = __webpack_public_path__ + "static/media/carousel-3-origin.ca3295c9.jpg";